import { Navigate, Outlet } from 'react-router-dom'

import navigateToNextOnboardingPageAction from '@actions/navigateToNextOnboardingPageAction'
import skipOnboardingLoader from '@app-studio-web/ui/loaders/skipOnboardingLoader'

import FeedbackBuildingPlanPage from './FeedbackBuildingPlan'
import FeedbackEmotionalAwarenessPage from './FeedbackEmotionalAwareness'
import FeedbackFeelingsPage from './FeedbackFeelings'
import FeedbackGenderStudyPage from './FeedbackGenderStudy'
import FeedbackIntentionsPage from './FeedbackIntentions'
import FeedbackOverwhelmPage from './FeedbackOverwhelm'
import FeedbackReasonsPage from './FeedbackReasons'
import FeedbackResetPage from './FeedbackReset'
import FeedbackStressPage from './FeedbackStress'
import QuestionAgePage from './QuestionAge'
import QuestionCheckInPage from './QuestionCheckIn'
import QuestionCommitmentPage from './QuestionCommitment'
import QuestionEmotionalAwarenessPage from './QuestionEmotionalAwareness'
import QuestionFeelingsPage from './QuestionFeelings'
import QuestionGenderPage from './QuestionGender'
import QuestionHowYouFeelPage from './QuestionHowYouFeel'
import QuestionImagineYourselfPage from './QuestionImagineYourself'
import QuestionOverwhelmPage from './QuestionOverwhelm'
import QuestionPastAttemptsPage from './QuestionPastAttempts'
import QuestionReasonsPage from './QuestionReasons'
import QuestionResetPage from './QuestionReset'
import QuestionSleepQualityPage from './QuestionSleepQuality'
import QuestionStressLevelPage from './QuestionStressLevel'

const onboardingRoutes = [
  {
    path: '/onboarding',
    element: <Outlet />,
    loader: skipOnboardingLoader,
    children: [
      {
        element: <Navigate to="question-imagine-yourself" replace />,
        index: true,
      },
      // 1. Gender question (first) - keeps original URL for marketing
      {
        action: navigateToNextOnboardingPageAction,
        element: <QuestionGenderPage />,
        path: 'question-imagine-yourself',
      },
      // 2. Gender study feedback
      {
        action: navigateToNextOnboardingPageAction,
        element: <FeedbackGenderStudyPage />,
        path: 'feedback-gender-study',
      },
      // 3. Age question
      {
        action: navigateToNextOnboardingPageAction,
        element: <QuestionAgePage />,
        path: 'question-age',
      },
      // 4. Imagine yourself (original content, new path)
      {
        action: navigateToNextOnboardingPageAction,
        element: <QuestionImagineYourselfPage />,
        path: 'question-future-self',
      },
      // 5. Intentions feedback (original)
      {
        action: navigateToNextOnboardingPageAction,
        element: <FeedbackIntentionsPage />,
        path: 'feedback-intentions',
      },
      // 6. Stress level slider
      {
        action: navigateToNextOnboardingPageAction,
        element: <QuestionStressLevelPage />,
        path: 'question-stress-level',
      },
      // 7. Stress feedback
      {
        action: navigateToNextOnboardingPageAction,
        element: <FeedbackStressPage />,
        path: 'feedback-stress',
      },
      // 8. Sleep quality
      {
        action: navigateToNextOnboardingPageAction,
        element: <QuestionSleepQualityPage />,
        path: 'question-sleep-quality',
      },
      // 9. Overwhelm frequency
      {
        action: navigateToNextOnboardingPageAction,
        element: <QuestionOverwhelmPage />,
        path: 'question-overwhelm',
      },
      // 10. Overwhelm feedback
      {
        action: navigateToNextOnboardingPageAction,
        element: <FeedbackOverwhelmPage />,
        path: 'feedback-overwhelm',
      },
      // 11. How you feel (original)
      {
        action: navigateToNextOnboardingPageAction,
        element: <QuestionHowYouFeelPage />,
        path: 'question-how-you-feel',
      },
      // 12. Emotional awareness
      {
        action: navigateToNextOnboardingPageAction,
        element: <QuestionEmotionalAwarenessPage />,
        path: 'question-emotional-awareness',
      },
      // 13. Emotional awareness feedback
      {
        action: navigateToNextOnboardingPageAction,
        element: <FeedbackEmotionalAwarenessPage />,
        path: 'feedback-emotional-awareness',
      },
      // 14. Reasons (original)
      {
        action: navigateToNextOnboardingPageAction,
        element: <QuestionReasonsPage />,
        path: 'question-reasons',
      },
      // 15. Reasons feedback (original)
      {
        action: navigateToNextOnboardingPageAction,
        element: <FeedbackReasonsPage />,
        path: 'feedback-reasons',
      },
      // 16. Past attempts
      {
        action: navigateToNextOnboardingPageAction,
        element: <QuestionPastAttemptsPage />,
        path: 'question-past-attempts',
      },
      // 17. Check-in time (original)
      {
        action: navigateToNextOnboardingPageAction,
        element: <QuestionCheckInPage />,
        path: 'question-check-in',
      },
      // 18. Commitment level
      {
        action: navigateToNextOnboardingPageAction,
        element: <QuestionCommitmentPage />,
        path: 'question-commitment',
      },
      // 19. Feelings coping (original)
      {
        action: navigateToNextOnboardingPageAction,
        element: <QuestionFeelingsPage />,
        path: 'question-feelings',
      },
      // 20. Feelings feedback (original)
      {
        action: navigateToNextOnboardingPageAction,
        element: <FeedbackFeelingsPage />,
        path: 'feedback-feelings',
      },
      // 21. Reset question (original)
      {
        action: navigateToNextOnboardingPageAction,
        element: <QuestionResetPage />,
        path: 'question-reset',
      },
      // 22. Reset feedback (original)
      {
        action: navigateToNextOnboardingPageAction,
        element: <FeedbackResetPage />,
        path: 'feedback-reset',
      },
      // 23. Building personalized plan (final)
      {
        action: navigateToNextOnboardingPageAction,
        element: <FeedbackBuildingPlanPage />,
        path: 'feedback-building-plan',
      },
    ],
  },
]

export default onboardingRoutes
